import { makeVar } from '@apollo/client'

export const activeProjectsVar = makeVar<$TSFixMe[]>([])
